import axios from "axios";

// Chiamate same-origin: il traffico /api viene instradato al backend
// su qualsiasi host serva il frontend (preview, dominio apex, www).
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err, fallback = "Si è verificato un errore. Riprova.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || String(e)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}
